import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import CoreMixin from '@nodes/mixins/Core';
import Props from './props';

@Component({
    components: {},
})

/**
 * @name ListWrapper
 */
export default class ListWrapper extends Mixins(HybridMixin, Props, CoreMixin) {
    posts: Array<object> = [];
    metadata: Array<object> = [];

    /**
     * Return list items
     *
     * @returns {Array}
     */
    get postsList(): Array<any> {
        return this.posts && this.posts.length ? this.posts : this.items;
    }

    /**
     * return true if loading be on.
     *
     * @returns {boolean}
     */
    get hasLoading(): boolean {
        return this.getValue('loading') || this.getValue('loadingOn') || this.$wait.is('loading-list-wrapper-rogue');
    }

    /**
     * Fetch Data
     */
    fetchItems() {
        this.$wait.start('loading-list-wrapper');
        const api: {[k: string]: any} = {
            service: this.getObject('endpoint', 'service'),
            name   : this.getObject('endpoint', 'name'),
            params : this.getObject('endpoint', 'params'),
        };
        this.$services[api.service][api.name]({
            limit: this.getValue('limit'),
            ...api.params,
        }).then((response: { data: { results: object[] | Array<any>; metadata: object[]; }; }) => {
            this.posts = response.data.results;
            this.metadata = response.data.metadata;
            if (!response.data.results.length) {
                this.$parent.$emit('empty', 0);
            }
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end('loading-list-wrapper');
        });
    }

    /**
     * @inheritdoc
     */
    created() {
        if (this.getValue('endpoint')) {
            this.fetchItems();
        }
    }
}
